var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-answer quiz-answer-select",class:{
        'quiz-answer-checked': _vm.isChecked,
      },on:{"click":_vm.updateState}},[_c('span',{staticClass:"quiz-answer-icon",class:{
        'quiz-answer-icon-checked': _vm.isChecked,
      }}),_c('div',{staticClass:"quiz-answer-title"},[_vm._v(" "+_vm._s(_vm.answer.title || '')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }